import { IPreloadedState } from 'shared/types/redux';

export const selectHouseCoordinates = (state: IPreloadedState) => state.houseInfo.geo.coordinates;
